jQuery(function($){
	console.log('Who\'s Up Live Integration');

	if($('body').hasClass('has-whosup-data') && $('#whosup-refresh-interval').length) {
		const refreshInterval = $('#whosup-refresh-interval').val();
		console.log('refreshInterval', refreshInterval);

		if(refreshInterval > 0) {
			setInterval(load_whosup_data, parseInt(refreshInterval) * 1000);
		}

		function load_whosup_data() {
			$('.whosup-data').each(function(){
				const el = $(this);
				const entrantDiv = el.find('.current-entrant');

				entrantDiv.addClass('refreshing');

				const data = {
					action: 'ajax_update_whosup_data',
					event_id: el.attr('event_id'),
				};

				$.post('/wp-admin/admin-ajax.php', data, function(response){
					console.log(response);
					entrantDiv.html(response);
					entrantDiv.removeClass('refreshing');
				});
			});
		}
	}
});